import { render, staticRenderFns } from "./wfh.vue?vue&type=template&id=19c15490&scoped=true&"
var script = {}
import style0 from "./wfh.vue?vue&type=style&index=0&id=19c15490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c15490",
  null
  
)

export default component.exports